import {
  Checkbox,
  Dropdown,
  Icon,
  PrimaryButton,
  Stack,
  TextField,
  Calendar,
  TooltipHost,
  Toggle,
} from "@fluentui/react";
import React, { useContext, useState, useCallback, useRef } from "react";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import FilterPopUp from "./FilterPopUp";
import {
  LeftArrowFunction,
  RightArrowFunction,
} from "../../helpers/helpingFunctions";
import { dropdownStyles } from "../../helpers/initData";
import DropdownMoreIcon from "../../../../components/SVGComponents/DropdownMoreIcon";
import themeContext from "../../../../context/theme/ThemeContext";
import BasicViewerSwitch from "../../../../components/SVGComponents/BasicViewerSwitch";
import { BASIC_STUDYLIST, USERTYPES } from "../../../../constants/Constants";

import { t } from "i18next";
import SearchFilter from "./Components/SearchFilter";
import SortFilter from "./Components/SortFilter";
import ContentFilter from "./Components/ContentFilter";
import ApplyFilter from "./Components/ApplyFilter";
import DataToggleFilter from "./Components/DataToggleFilter";
import GlobalSearchToggle from "./Components/GlobalSearchToggle";
import { getEnv } from '../../../../helpers/EnvHelper';

const Filters = (props) => {
  const {
    setAllStudies,
    studyData,
    columns,
    allStudies,
    searchDto,
    setSearchDto,
    sortGlobal,
    setSortGlobal,
    filterInputValues,
    showFilters,
    setShowFilters,
    setApplyClick,
    filterBadges,
    setFilterBadges,
    removeBadgeFromFilter,
    storefilterBadges,
    setPatientDetail,
    trackApplyButton,
    setTrackApplyButton,
    patientNameBadgeShow,
    setPatientNameBadgeShow,
    handleEnterKeyPress,
    setFilterInputValues,
    storefilterInputValues,
    handleRefresh,
    roles
  } = useContext(studylistContext);

  const { theme, themeName, setThemeName, setTheme } = useContext(themeContext);
 
  return (
  <>
      <div className="study-list-sort-filter-container" 
      style={{
        padding : getEnv("REACT_APP_VDC_PLATFORM") === "true" ? "5px 10px 2px 10px" : "10px 10px 5px 10px",
        background: themeName === "light" ? "#EEEEEE":"var(--studylist-search-and-tab-section-background)"
      }}>
        <div data-tut={"tour-filter-section"} className="section-filter">
          <div
            style={{
              display: "flex",
              gap: "4px",
              alignItems: "center",
              // width: storefilterBadges.length > 0 ? "90%" : "fit-content",
              marginRight: "4px"
            }}
          >
            <SearchFilter />
            <SortFilter />   
          </div>
          <div className="content-filter-desktop">
            <ContentFilter handleClearFilter={props.handleClearFilter} />
          </div>
        </div>
        <div className="content-filter-mobile">
          <ContentFilter handleClearFilter={props.handleClearFilter} />
        </div>
        <div className="study-list-toggle-group">
          {(getEnv("REACT_APP_PARTITION_MODE") == "true" && getEnv("REACT_APP_HYBRID_MODE") === "false") &&
            <DataToggleFilter />}
          {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR) &&
            <GlobalSearchToggle />}
        </div>

        <ApplyFilter handleClearFilter={props.handleClearFilter} />
    </div>
  </>
  );
};

export default Filters;
